import _ from "lodash";
import Vue from "vue";
import { BASEURL } from "@/config/index";
import constant from "@/helper/constant";
import { getNumberFormatter } from "@/helper/currencyFormat";
import { getLangSpecificAttribute } from "@/helper/Languages";
import axios from "axios";
// import { getLangSpecificContent } from "@/helper/LanguageHelperV2";
import { authenticationService } from "@/services/AuthenticationService";

const beforeMount = function() {
  // this.$store.dispatch("fetchGlobalOptions");
  // this.$store.dispatch("fetchOrgDetails");
};

let userDetailsArray = {
  cinema_id: null,
  email_id: null,
  first_name: null,
  last_name: null,
  middle_name: null,
  mobile_no: null,
  role_id: null,
  user_id: null,
  username: null,
  role_name: null,
  distributor_id: null,
  cine_name: null,
  cine_direct_sale: null,
  cine_include_float_amount: null,
  cine_sell_fnb_in_boxoffice: null,
  pos_location_access: null,
  is_premier_kitchen_user: "N",
};
const data = function() {
  return {
    LOADING: null,
    AdminError:
      "Sorry! Something went wrong. kindly contact your administrator",
    GridViewFlag: false,
    NoRecords: "NoRecords",
    BASE_URL: constant.imageBaseURL,
    imageBaseURL: constant.imageBaseURL,
    imageS3BaseURL: constant.imageS3BaseURL,
    data_loading: false,
    usersArray: Object.keys(userDetailsArray),
    UsersDetails: {
      ...userDetailsArray,
    },
    OrganizationGlobalOptions: [],
    secureStore: {
      set: authenticationService.set,
      get: authenticationService.get,
      remove: function(key) {
        window.localStorage.removeItem(key);
      },
    },
    toursShownOnPage: [],
    getMycinemaStatus: "N",
  };
};
const computed = {
  globaloptionsArr() {
    return this.$store.getters.getGlobalOptions;
  },
  _getCountryList() {
    return (key, Id) => {
      return [];
    };
  },
  curr_code_mixin() {
    return this.$store.getters.getCurrencyData["curr_code"];
  },
  currency() {
    return this.$store.getters.getCurrencyData;
  },
  GetRoleId() {
    const { role_id } = authenticationService.get("USINFO");
    return role_id;
  },
  _DateFormat() {
    return constant.dateFormat;
  },
  // currFormat() {
  //   let cFormat;
  //   let precesion;
  //   let global_options_latest = this.$store.getters.getGlobalOptions;
  //   cFormat = global_options_latest
  //     ? global_options_latest.find((x) => {
  //         return x.go_key == "CURR_FORMAT";
  //       })
  //     : null;
  //   precesion = global_options_latest
  //     ? global_options_latest.find((x) => {
  //         return x.go_key == "MIN_FRACTION_DIGITS";
  //       })
  //     : 2;
  //   if (cFormat && cFormat.go_value) {
  //     cFormat = cFormat.go_value;
  //   } else {
  //     cFormat = "en-US";
  //   }
  //   if (precesion && precesion.go_value) {
  //     precesion = precesion.go_value;
  //   } else {
  //     precesion = 2;
  //   }

  //   let CLIENT_SETUP_NAME = ""

  //   const CLIENTINFO = global_options_latest
  //     ? global_options_latest.find((x) => {
  //         return x.go_key == "CLIENT_SETUP_NAME";
  //       })
  //     : null;

  //     if(CLIENTINFO && CLIENTINFO.go_value) {
  //       CLIENT_SETUP_NAME = CLIENTINFO.go_value
  //     }

  //     console.log('CLIENT_SETUP_NAME', CLIENT_SETUP_NAME);
  //     console.log('CLIENT_NAME', this.CLIENT_NAME);
      

  //   if(CLIENT_SETUP_NAME == "starcinemas") {
  //     cFormat ='en-IN';
  //     precesion = 0;
  //   } else {
  //     precesion = precesion || 3;
  //   }
  //   return getNumberFormatter(cFormat, precesion);
  // },
  currFormat() {
    let cFormat;
    let precesion;
    let global_options_latest = [];
    let orgName = localStorage.getItem("setUpName");
    this.isStarClient = orgName.includes("starcinemas") ? true : false;
    let CLIENT_SETUP_NAME = ""
    if(CLIENT_SETUP_NAME == "starcinemas") {
      precesion = 0;
      cFormat ='en-IN';
    } else {
      precesion = 2;
      cFormat = "en-US";
    }
    return getNumberFormatter(cFormat, precesion);
  },
   currFormat4() {
    let cFormat;
    let precesion;
    let global_options_latest = [];
    let orgName = localStorage.getItem("setUpName");
    this.isStarClient = orgName.includes("starcinemas") ? true : false;
    let CLIENT_SETUP_NAME = ""
      precesion = 0;
      cFormat = "en-US";
    return getNumberFormatter(cFormat, precesion);
  },
  currFormat3() {
    let cFormat;
    let precesion;
    let global_options_latest = this.$store.getters.getGlobalOptions;
    cFormat = global_options_latest
      ? global_options_latest.find((x) => {
          return x.go_key == "CURR_FORMAT";
        })
      : null;
    precesion = global_options_latest
      ? global_options_latest.find((x) => {
          return x.go_key == "MIN_FRACTION_DIGITS";
        })
      : null;
    if (cFormat && cFormat.go_value) {
      cFormat = cFormat.go_value;
    } else {
      cFormat = "en-US";
    }
    if (precesion && precesion.go_value) {
      precesion = precesion.go_value;
    } else {
      precesion = 2;
    }
    precesion = 3;
    return getNumberFormatter(cFormat, precesion);
  },
  CLIENT_SETUP_NAME() {
    return this.$store.getters.CLIENT_SETUP_NAME;
  },
  POS_AUDIT_LOGS_ACTIVE() {
    return this.$store.getters.POS_AUDIT_LOGS_ACTIVE;
  },
};
import MasterService from "@/services/MasterService";
import LogService from "@/services/LogService";
import moment from "moment";
import { CLIENT_NAME } from "@/helper/Role";
const getFirstUserData = async (user_id) => {
  const { data } = await MasterService.GetUserInfoById({ user_id });
  return data;
};
const methods = {
  sendAuditLogs(payload) {
    if (this.POS_AUDIT_LOGS_ACTIVE == "Y") {
      let logObj = {
        user_name: null,
        user_id: this.getUserDetail("user_id"),
        cinema_id: this.getCinemaId(),
        action: null,
        page_name: null,
        logDateTime: null,
        api_name: window.location.hash,
        ip: null,
        country_name: null,
        country_code: null,
        latitude: null,
        longitude: null,
        currency_code: null,
        currency_name: null,
        ...payload,
      };
      LogService.SendLog(logObj)
        .then((response) => {
          const { data } = response;
          if (data && data.status) {
            console.log("Log Inserted");
          } else {
            console.error("Status Error on sendLogs :", data.message);
          }
        })
        .catch((error) => {
          console.error("Catch Error on sendLogs :", error);
        });
    }
  },
  authorizeClient(clientNames) {
    let isShow = false;
    let globaloptionsArr = this.globaloptionsArr;
    let clientSetupName = globaloptionsArr.find((globalOption) => {
      return globalOption.go_key == "CLIENT_SETUP_NAME";
    })["go_value"];

    if (clientNames.length > 0 && clientSetupName) {
      isShow = clientNames.includes(clientSetupName);
    }
    console.log(
      "this.$store.getters.CLIENT_SETUP_NAME",
      clientSetupName,
      clientNames,
      isShow,
      "from mixins"
    );
    return isShow;
  },
  showLoading: function() {
    this.hideLoading(true);
    document.body.classList.add("sales-report-loading");
    this.$nextTick(() => {
      this.LOADING = this.$loading.show();
    });
  },
  hideLoading: function(immediate = false) {
    document.body.classList.remove("sales-report-loading");
    if (!immediate) {
      this.$nextTick(() => {
        if (this.LOADING) this.LOADING.hide();
      });
    } else {
      if (this.LOADING) this.LOADING.hide();
    }
  },
  getRequestBody: function(method = "GET", array = [], Methods = {}) {
    let payload = {};
    (async function() {
      const promises = array.map((x) => {
        payload[x.fieldname] = x.fieldvalue;
      });
      await Promise.all(promises);
      // payload['table'] = Methods["tableName"]
    })();
    if (method == "POST") {
      return {
        url: Methods[method] + Methods["tableName"], // + Methods["urlKey"],
        method,
        payload,
      };
    } else if (method == "PUT") {
      let url = null;
      console.log("Method :", Methods["params"]);
      if (Methods["params"]) {
        url =
          Methods[method] +
          Methods["tableName"] +
          `/${Methods["params"]["id"]}`;
      } else {
        url = Methods[method] + Methods["tableName"];
      }
      console.log("url :", url);

      return {
        url,
        method: "PUT",
        payload,
      };
    } else if (method == "GET") {
      let url = null;
      if (Methods["params"]) {
        url =
          Methods[method] +
          Methods["tableName"] +
          `/${Methods["params"]["id"]}`;
      } else {
        url = Methods[method] + Methods["tableName"];
      }

      return {
        url,
        method: "GET",
        payload: {},
      };
    } else if (method == "GET_ONE") {
      let url = null;
      if (Methods["params"]) {
        url =
          Methods[method] +
          Methods["tableName"] +
          `/${Methods["params"]["id"]}`;
      } else {
        url = Methods[method] + Methods["tableName"];
      }

      return {
        url,
        method: "GET",
        payload: {},
      };
    } else {
      return {
        url: "",
        method: "GET",
        payload: {},
      };
    }
  },
  /**
   * How to use Ref: [https://github.com/vuejs/vue/issues/11088#issuecomment-630287153]
   *  <template>
   *    <div>
   *      {{ getSafe(() => obj.foo.bar) }} ............................ <!-- returns 'baz' -->
   *      {{ getSafe(() => obj.foo.doesNotExist) }} ................... <!-- returns undefined -->
   *      {{ getSafe(() => obj.foo.doesNotExist, 'fallbackValue') }}... <!-- returns 'fallbackValue' -->
   *    </div>
   *  </template>
   */
  getSafe(
    fn,
    fallbackValue = undefined,
    useFallbackForFalsyGetSafeValue = true
  ) {
    try {
      let result = fn();

      if (!result && useFallbackForFalsyGetSafeValue) {
        result = fallbackValue;
      }

      return result;
    } catch (e) {
      return fallbackValue;
    }
  },

  validateShowCinema(cinema_id) {
    console.log(
      "VALIDATING CINEMA...",
      cinema_id,
      authenticationService.get("USINFO").cinema_id
    );
    let loggedCinemaId = window.localStorage.getItem("cinema_id");
    let userId = authenticationService.get("USINFO").user_id;
    let status = true;
    if (cinema_id && loggedCinemaId) {
      if (
        cinema_id == authenticationService.get("USINFO").cinema_id &&
        loggedCinemaId == cinema_id
      ) {
        status = true;
      } else {
        status = false;
      }
    } else {
      status = false;
    }
    if (!status) {
      this.$store.dispatch("onSetAndSendLog", {
        action: `Validate Cinema ID FALIED WE GET SHOW CINEMA ID ${cinema_id} but USER CINEMA ID IS ${loggedCinemaId} and user id is ${userId}`,
        page_name: "POS booking",
        api_name: window.location.hash,
      });
    }
    console.log("VALIDATE CINEMA STATUS", status);
    return status;
  },
  getNegativeValue(value) {
    if (value) {
      return "-" + parseFloat(value).toFixed(2);
    } else {
      return parseFloat(0).toFixed(2);
    }
  },
  getGlobalOptionKey(key_name) {
    if (this.$store) {
      let global_array = this.$store.getters.getGlobalOptions;
      if (global_array.length > 0) {
        return global_array;
      }
    }
  },
  getMyCinemaStatusNew() {
    return this.secureStore.get("MYCINEMASTATUS");
  },
  goBack: function(error) {
    this.$router.go(-1);
  },
  _CatchError: function(error) {
    // console.log('errr::::', error)
    Vue.toasted.show(
      error || "Sorry! Something went wrong. kindly contact your administrator"
    );
  },
  _GoToSomethingWentWrong: function() {
    this.$router.push({
      path: "/something-went-wrong",
    });
  },
  _GoToAccessDenied: function() {
    this.$router.push({
      path: "/access-denied",
    });
  },
  _GoToError404: function() {
    this.$router.push({
      path: "/404",
    });
  },
  _GoToRoute: function(path) {
    this.$router.push({
      path: path,
    });
  },

  GetViewUsersDetails: function(user_id) {
    let string = "";
    let promise = getFirstUserData(user_id).then((res) => {
      string =
        res.status && res["Records"] && res.Records.length > 0
          ? res.Records[0].user_name
          : "-";
    });
    // console.log('promise :', promise);
    // console.log('string :', string);
    // getFirstUserData(user_id).map(x => { console.log('x :', x); })
    return promise;
  },
  CreateFilterObject: function(array) {
    let obj = {};
    array.map((x) => {
      obj[x.key] = "";
    });
    return obj;
  },
  GetMonthFirstDate: function() {
    var d = new Date(),
      month = "" + (d.getMonth() + 1),
      day = "" + d.getDate(),
      year = d.getFullYear();

    if (month.length < 2) month = "0" + month;
    if (day.length < 2) day = "0" + day;

    return [year, month, "01"].join("-");
  },
  GetCurrentDate: function() {
    var d = new Date(),
      month = "" + (d.getMonth() + 1),
      day = "" + d.getDate(),
      year = d.getFullYear();

    if (month.length < 2) month = "0" + month;
    if (day.length < 2) day = "0" + day;

    return [year, month, day].join("-");
  },
  formatDate: function(date) {
    var d = new Date(date),
      month = "" + (d.getMonth() + 1),
      day = "" + d.getDate(),
      year = d.getFullYear();

    if (month.length < 2) month = "0" + month;
    if (day.length < 2) day = "0" + day;
    return [year, month, day].join("-");
  },
  _formatDate_dd_mm_yyyy: function(date) {
    var d = new Date(date);
    let formatted_date =
      d.getDate() +
      "-" +
      (d.getMonth() + 1) +
      "-" +
      d.getFullYear() +
      " " +
      d.getHours() +
      ":" +
      d.getMinutes();
    return formatted_date;
  },

  _GetImagePath: function(imagePath) {
    if (imagePath && imagePath.length > 0) {
      var expression = /(https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]+\.[^\s]{2,}|www\.[a-zA-Z0-9]+\.[^\s]{2,})/gi;
      var regex = new RegExp(expression);

      if (imagePath.match(regex)) {
        return imagePath;
      }
      if (imagePath.match(/S3\//g)) {
        return `${constant.imageS3BaseURL}${imagePath}`;
      } else {
        return `${constant.imageBaseURL}${imagePath}`;
      }
    }
  },

  _downloadImagePath: function(imagePath, fileName) {
    let imageUrl = `${constant.imageBaseURL}${imagePath}`;
    axios
      .get(imageUrl, { responseType: "blob" })
      .then((response) => {
        console.log(response.data);
        const blob = new Blob([response.data]);
        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.download = fileName;
        link.click();
        URL.revokeObjectURL(link.href);
      })
      .catch(console.error);
  },
  getCurrentDateNew(format) {
    if (format) {
      return moment().format(format);
    } else {
      return moment().format("YYYY-MM-DD");
    }
  },
  getCurrentTime() {
    return moment().format("HH:mm");
  },

  getCinemaId() {
    return localStorage.getItem("cinema_id") || null;
  },
  getUserDetail(key = null) {
    let user_info = localStorage.getItem("USER_INFO") || null;
    if (user_info) {
      user_info = JSON.parse(localStorage.getItem("USER_INFO"));
    }
    if (key) {
      return user_info[key];
    } else {
      return user_info;
    }
  },
  getUserShiftData(key = null) {
    let user_info = localStorage.getItem("USER_SHIFT_DATA") || null;
    if (user_info) {
      user_info = JSON.parse(localStorage.getItem("USER_SHIFT_DATA"));
    }
    if (key) {
      return user_info[key];
    } else {
      return user_info;
    }
  },
  getSpecificGlobalOption(key = null) {
    let globalOptions = this.globaloptionsArr;
    let globalOptionValue = "";
    if (globalOptions.length > 0 && key != null) {
      let findGlobalOption = globalOptions.find((globalOption) => {
        return globalOption.go_key === key;
      });
      if (findGlobalOption && Object.keys(findGlobalOption).length > 0) {
        globalOptionValue = findGlobalOption.go_value;
      } else {
        globalOptionValue = "";
      }
    }
    console.log({ globalOptionValue }, "from globalOtpionValue");
    return globalOptionValue;
  },

  getReportDates(reportRoute) {
    let fromDate = window.localStorage.getItem("fromDate");
    let toDate = window.localStorage.getItem("toDate");
    let obj = {
      fromDate: moment().format("YYYY-MM-DD"),
      toDate: moment().format("YYYY-MM-DD"),
      reportRoute: window.localStorage.getItem("reportRoute"),
    };
    if (reportRoute == obj.reportRoute && fromDate && toDate) {
      obj["fromDate"] = moment(fromDate).format("YYYY-MM-DD");
      obj["toDate"] = moment(toDate).format("YYYY-MM-DD");
    }
    return obj;
  },
  setReportDates(obj) {
    let objectKeys = Object.keys(obj);
    if (objectKeys.length) {
      objectKeys.forEach((key) => {
        window.localStorage.setItem(key, obj[key]);
      });
    }
    return true;
  },

  getLangSpecificAttribute,
  // getLangSpecificContent,
};

const beforeDestroy = function() {};

const storeService = {
  data: () => data(),
  computed,
  beforeMount,
  methods,
  beforeDestroy,
};

export default storeService;



// WEBPACK FOOTER //
// ./src/util/utilMixin/index.js